import { render } from "./index.vue?vue&type=template&id=7ce12559&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=7ce12559&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce12559"],['__file',"resources/js/v2/modules/whatsapp/pages/labels/create-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ce12559"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ce12559', __exports__)) {
    console.log('reload')
    api.reload('7ce12559', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7ce12559&scoped=true", () => {
    console.log('re-render')
    api.rerender('7ce12559', render)
  })

}


export default __exports__